import {cx} from "@emotion/css";
import {ButtonProps, Button as MuiButton} from "@mui/material";
import MuiLoadingButton from "@mui/lab/LoadingButton";
import {useMemo} from "react";

import {noop} from "~/utils/noop";

import {IButton} from "../IButton";
import {styles} from "./ErrorButton.styles";
import {commonStyles} from "../_common/styles";

export interface BmErrorButtonProps
  extends Pick<IButton, "id" | "className" | "sx" | "type" | "form" | "disabled" | "size" | "onClick" | "children"> {
  color?: ButtonProps["color"];
  loading?: boolean;
  loadingIndicator?: string;
}

export const BmErrorButton: React.FC<BmErrorButtonProps> = ({
  className,
  loading,
  loadingIndicator,
  color = "error",
  size = "large",
  onClick,
  ...restProps
}) => {
  const commonProps = useMemo(
    () => ({
      className: cx(commonStyles.button, styles.errorButton, className),
      color,
      size,
      disableFocusRipple: true,
      ...restProps,
    }),
    [className, size, restProps, color],
  );

  return loading === undefined ? (
    <MuiButton variant="contained" onClick={onClick} {...commonProps} />
  ) : (
    <MuiLoadingButton
      variant="contained"
      loading={loading}
      loadingIndicator={loadingIndicator}
      onClick={loading ? noop : onClick}
      {...commonProps}
    />
  );
};
